import "@/assets/css/bootstrap.css";
import "@/assets/style.css";
import "@/assets/css/dark.css";
import "@/assets/css/swiper.css";
import "@/assets/demos/shop/shop.css";
import "@/assets/demos/shop/css/fonts.css";
import "@/assets/css/font-icons.css";
import "@/assets/css/responsive.css";


import Vue from "vue";

import axios from "axios";

import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';

import App from "./App.vue";
import router from "./router";
import store from "./store";
import VCalendar from "v-calendar";
// import vuetify from '@/plugins/vuetify' // path to vuetify export
Vue.use(VCalendar, {
  // ...some defaults
  screens: {
    tablet: "576px",
    laptop: "992px",
    desktop: "1200px"
  }
  // ...other defaults
});

Vue.use(VueSweetalert2);

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBdKTA0X8_tFeOKcH1gm1HMyAepyXJ9hSk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // v: '3.26',
  },
  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});

Vue.prototype.$http = axios;

Vue.config.productionTip = false;
import Buefy from 'buefy'
// import "@/assets/css/buefy.css"
import 'buefy/dist/buefy.css'

// Vue.use(Buefy)

Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultContainerElement: '#content',
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");